import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index/index'
import qyjj from '@/components/qyjj/qyjj.vue'
import qywh from '@/components/qyjj/qywh.vue'
import fzjg from '@/components/qyjj/fzjg.vue'
import zzjg from '@/components/qyjj/zzjg.vue'
import rygs from '@/components/qyjj/rygs.vue'
import zbxx from '@/components/zbxx/zbxx'
import jggg from '@/components/zbxx/jggg'
import zzgg from '@/components/zbxx/zzgg'
import gzgg from '@/components/zbxx/gzgg'
import gsdt from '@/components/gsdt/gsdt'
import qygg from '@/components/gsdt/qygg'
import qyxx from '@/components/qyxx/qyxx'
import shzr from '@/components/gsdt/shzr'
import zmt from '@/components/gsdt/zmt'
import jlyd from '@/components/jlyd/jlyd'
import zbxz from '@/components/jlyd/zbxz'
import jyjl from '@/components/jlyd/jyjl'
import kffw from '@/components/kffw/kffw'
import yjzs from '@/components/kffw/yjzs'
import rczp from '@/components/rczp/rczp'
import xztd from '@/components/rczp/xztd'
import bsxt from '@/components/bsxt/bsxt'
import reg from '@/components/bsxt/reg'
import user from '@/components/user/user.vue'
import newstxt from '@/components/newstxt/newstxt'
import zbxxtxt from '@/components/newstxt/zbxxtxt'
import zcfgtxt from '@/components/newstxt/zcfgtxt'
import '@/assets/css/common.css'
import '@/assets/css/index.css'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  base: __dirname,
  routes: [

    {
      path: '',
      name: '/index',
      component: index,
    },
    {
      path: '/index',
      name: 'index',
      component: index,
    },
    {
      path: '/qyjj',
      name: 'qyjj',
      component: qyjj,
    },
    {
      path: '/qywh',
      name: 'qywh',
      component: qywh,
    },
    {
      path: '/fzjg',
      name: 'fzjg',
      component: fzjg,
    },
    {
      path: '/rygs',
      name: 'rygs',
      component: rygs,
    },
    {
      path: '/zzjg',
      name: 'zzjg',
      component: zzjg,
    },
    {
      path: '/zbxx',
      name: 'zbxx',
      component: zbxx
    },
    {
      path: '/gzgg',
      name: 'gzgg',
      component: gzgg
    },
    {
      path: '/jggg',
      name: 'jggg',
      component: jggg
    },
    {
      path: '/zzgg',
      name: 'zzgg',
      component: zzgg
    },
    {
      path: '/yjzs',
      name: 'yjzs',
      component: yjzs,
    },
    {
      path: '/gsdt',
      name: 'gsdt',
      component: gsdt
    },
    {
      path: '/shzr',
      name: 'shzr',
      component: shzr
    },
    {
      path: '/qygg',
      name: 'qygg',
      component: qygg
    },
    {
      path: '/qyxx',
      name: 'qyxx',
      component: qyxx
    },
    {
      path: '/zmt',
      name: 'zmt',
      component: zmt
    },
    {
      path: '/jlyd',
      name: 'jlyd',
      component: jlyd
    },
    {
      path: '/zbxz',
      name: 'zbxz',
      component: zbxz
    },
    {
      path: '/jyjl',
      name: 'jyjl',
      component: jyjl
    },

    {
      path: '/kffw',
      name: 'kffw',
      component: kffw
    },
    {
      path: '/rczp',
      name: 'rczp',
      component: rczp
    },
    {
      path: '/xztd',
      name: 'xztd',
      component: xztd
    },
    {
      path: '/bsxt',
      name: 'bsxt',
      component: bsxt
    },

    {
      path: '/newstxt',
      name: 'newstxt',
      component: newstxt
    },
    {
      path: '/zbxxtxt',
      name: 'zbxxtxt',
      component: zbxxtxt
    },
    {
      path: '/zcfgtxt',
      name: 'zcfgtxt',
      component: zcfgtxt
    },
    {
      path: '/user',
      name: 'user',
      component: user
    },
    {
      path: '/reg',
      name: 'reg',
      component: reg
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js